// import React from "react";
// import "./App.scss";
// import Main from "./containers/Main";

// function App() {
//   return (
//     <div>
//       <Main />
//     </div>
//   );
// }

// export default App;

import React from 'react';

function App() {
  // Apni details yahan update kar lein
  const portfolioData = {
    email: 'mohammad.khizar2000@gmail.com', // apna email yahan dalein
    phone: '+92 3313276177',        // apna phone number yahan dalein
    resumeLink: 'https://drive.google.com/file/d/1osP57NID7DjbCTeHqf-PxHmsjyrGZsPs/view', // apna drive link
  };

  return (
    <div className="app-container">
      {/* --- UNCLOSABLE MAINTENANCE OVERLAY --- */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(15, 23, 42, 0.92)', // sleek dark overlay
          backdropFilter: 'blur(10px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999999,
          pointerEvents: 'all',
          padding: '20px',
          boxSizing: 'border-box',
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <div
          style={{
            backgroundColor: '#1e293b',
            color: '#f8fafc',
            borderRadius: '16px',
            padding: '36px 28px',
            maxWidth: '460px',
            width: '100%',
            textAlign: 'center',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.6)',
            border: '1px solid #334155',
          }}
        >
          {/* Icon */}
          <div style={{ fontSize: '46px', marginBottom: '14px' }}>
            🛠️
          </div>

          <h2
            style={{
              margin: '0 0 10px 0',
              fontSize: '22px',
              fontWeight: '700',
              letterSpacing: '-0.3px',
              color: '#ffffff',
            }}
          >
            Portfolio Under Maintenance
          </h2>

          <p
            style={{
              margin: '0 0 24px 0',
              color: '#94a3b8',
              fontSize: '14px',
              lineHeight: '1.6',
            }}
          >
            I am currently upgrading my portfolio with new projects and updates. 
            In the meantime, feel free to reach out directly or download my resume below.
          </p>

          {/* Resume Button */}
          <a
            href={portfolioData.resumeLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              width: '100%',
              padding: '12px 20px',
              backgroundColor: '#2563eb',
              color: '#ffffff',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '14px',
              boxSizing: 'border-box',
              transition: 'background-color 0.2s ease',
              marginBottom: '24px',
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1d4ed8')}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#2563eb')}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            View / Download Resume
          </a>

          {/* Divider */}
          <div
            style={{
              height: '1px',
              backgroundColor: '#334155',
              margin: '0 0 20px 0',
            }}
          />

          {/* Contact Details */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              fontSize: '13.5px',
              color: '#cbd5e1',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#94a3b8' }}>Email:</span>
              <a
                href={`mailto:${portfolioData.email}`}
                style={{ color: '#38bdf8', textDecoration: 'none', fontWeight: '500' }}
              >
                {portfolioData.email}
              </a>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#94a3b8' }}>Phone:</span>
              <a
                href={`tel:${portfolioData.phone}`}
                style={{ color: '#38bdf8', textDecoration: 'none', fontWeight: '500' }}
              >
                {portfolioData.phone}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Aapka existing code / routes neeche as it is rahenge */}
      {/* <YourMainPortfolioContent /> */}
    </div>
  );
}

export default App;